import React from "react";
import { ParagraphProps } from "components/atoms/Paragraph/types";
import { ParagraphElement } from "components/atoms/Paragraph/styles";

const Paragraph: React.FC<ParagraphProps> = ({ value, size }) => {
  return <ParagraphElement size={size}>{value}</ParagraphElement>;
};

export default Paragraph;
